import { createAction, handleActions } from 'redux-actions';
import { call, put, takeLatest, select } from 'redux-saga/effects';
import { requestDMPost } from 'modules/fetch/api';
import { activeModal } from 'modules/actions/statusMenu';
import { setResponse } from 'modules/actions/quality';

import moment from 'moment';

const SEND_STAR_SCORE = 'starScore/SEND_STAR_SCORE';
const GET_CHAT_RESULT = 'chat/GET_CHAT_RESULT';

export const sendSatisfy = createAction(SEND_STAR_SCORE);

export default function* sendSatisfyaction(action) {
  const paramSet = {
    param: {
      in_type: "satisfy",
      session_id: sessionStorage.getItem("session_id"),
      dialogue_id: sessionStorage.getItem("dialogue_id"),
      domain_id: process.env.REACT_APP_DOMAIN_ID,
      parameters: {
        star: action.payload.score.toString(),
        rate_msg: action.payload.content,
      },
    },
  };

  const response = yield call(requestDMPost, paramSet);

  yield put(setResponse([{ text : '소중한 의견 감사합니다.'}]));
  yield put(activeModal('feedbackResponseModal'));
}
export function* sendSatisfyactionSaga() {
  yield takeLatest(SEND_STAR_SCORE, sendSatisfyaction);
}

// export function* getChatListSaga() {
//   yield takeLatest(GET_CHAT_LIST, sendSatisfyaction);
// }

// export default starScore;
